import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from "../store";

export interface BasicLogin {
    username: string;
    password: string;
    code: string;
    showNews: boolean;
    showPrices: boolean;
}

interface AuthorizationState {
  loggedIn: boolean;
  accessToken: string;
  tokenExpiryDate: string;
  isMuted: boolean;
  enableSpeaking: boolean;
  basicLogin?: BasicLogin;
}

const initialState: AuthorizationState = {
  loggedIn: false,
  accessToken: '',
  tokenExpiryDate: '',
  isMuted: false,
  enableSpeaking: false,
  basicLogin: undefined,
};

export const authorizationSlice = createSlice({
  name: 'authorization',
  initialState,
  reducers: {
    setLoggedIn: (state, action: PayloadAction<boolean>) => {
      state.loggedIn = action.payload;
    },
    setAccessToken: (state, action: PayloadAction<string>) => {
      state.accessToken = action.payload;
    },
    setTokenExpiryDate: (state, action: PayloadAction<number>) => {
      const date = new Date()
      date.setSeconds(date.getSeconds() + action.payload);
      state.tokenExpiryDate = date.toISOString();
    },
    setIsMuted: (state, action: PayloadAction<boolean>) => {
        state.isMuted = action.payload;
      },
      setEnableSpeaking: (state, action: PayloadAction<boolean>) => {
        state.enableSpeaking = action.payload;
      },
      setBasicLogin: (state, action: PayloadAction<BasicLogin>) => {
        state.basicLogin = action.payload;
      },
  },
});

export const { setLoggedIn, setAccessToken, setTokenExpiryDate, setIsMuted, setEnableSpeaking, setBasicLogin } = authorizationSlice.actions;

export const selectIsLoggedIn = (state: RootState) => state.authorization.loggedIn;
export const selectAccessToken = (state: RootState) => state.authorization.accessToken;
export const selectTokenExpiryDate = (state: RootState) => state.authorization.tokenExpiryDate;
export const selectIsMuted = (state: RootState) => state.authorization.isMuted;
export const selectEnableSpeaking = (state: RootState) => state.authorization.enableSpeaking;
export const selectBasicLogin = (state: RootState) => state.authorization.basicLogin;

export default authorizationSlice.reducer;